class DisableDentistShareOnNonAvailability {
    constructor(element) {
        this.container = element;
        this.avSelects = this.container.querySelectorAll(
            "[data-share-dentist-av]"
        );
        this.bvSelects = this.container.querySelectorAll(
            '[data-interaction="UpdateAVGemak"]'
        );
        this.partnerAvSelects = this.container.querySelectorAll(
            "[data-share-dentist-id] > select"
        );
        this.dentistShareCheckBoxes = this.container.querySelectorAll(
            "[data-share-dentist-id] > [type=checkbox]"
        );
        this.dentistShareSettings = {
            ID: 0,
            value: "",
            element: null
        };

        this._init();
    }

    _init() {
        this._initOnLoad();
        this._assignListeners();
    }

    _initOnLoad() {
        /* NOTE:
           this is necessary instead of listening to DOMContentLoaded because there are already other eventlisteners
           in the legacy modules that are enforcing state or redrawing the dentist share checkbox (ノಠ益ಠ)ノ彡 ┻━┻
           Therefore the strategy is to listen a little bit later than DOMContentLoaded to enforce the correct state  */
        document.onreadystatechange = () => {
            if (document.readyState !== "loading") {
                for (const avSelect of this.avSelects) {
                    this._handleDentistShareOnNonAvailability({
                        target: avSelect
                    });
                }
            }

            // Force UpdateAVGemak module on load, so that non-availiable AVs will also work with AV-gemak... (ノಠ益ಠ)ノ彡 ┻━┻
            for (let bvSelect of this.bvSelects) {
                bvSelect.dispatchEvent(new Event("change"));
            }
        };
    }

    _assignListeners() {
        for (const avSelect of this.avSelects) {
            this._onChange(avSelect);
        }

        for (const partnerAvSelect of this.partnerAvSelects) {
            this._onChange(partnerAvSelect);
        }

        for (const dentistShareCheckBox of this.dentistShareCheckBoxes) {
            this._onChange(dentistShareCheckBox);
        }
    }

    _onChange(element) {
        element.addEventListener(
            "change",
            this._handleDentistShareOnNonAvailability.bind(this)
        );
    }

    _handleDentistShareOnNonAvailability({ target: element }) {
        // if [data-no-dental-sharing] is selected: stop _handleDentistShareOnNonAvailability, otherwise proceed
        if (this._checkAvSelectedNoDentalSharing(element)) return;

        this._setupShareDentist(element);
        this._disableDentistShareOnNonAvailability(element);
    }

    _checkAvSelectedNoDentalSharing(element) {
        let avSelectElementSelectedOptionElement = element.options
            ? element.options[element.selectedIndex]
            : null;

        return (
            avSelectElementSelectedOptionElement &&
            avSelectElementSelectedOptionElement.dataset.noDentalSharing === ""
        );
    }

    _setupShareDentist(element) {
        const avSelectElementID = element.parentNode.dataset.shareDentistId;
        const context = avSelectElementID ? "select" : "checkbox";

        switch (context) {
            case "select":
                this._setupShareDentistSettings(
                    avSelectElementID,
                    this.container.querySelector(
                        `[data-share-dentist-av="${
                            this.dentistShareSettings.ID
                        }"]`
                    ),
                    this.dentistShareSettings.element.value
                );
                break;
            case "checkbox":
                this._setupShareDentistSettings(
                    element.dataset.shareDentistAv,
                    element,
                    element.value
                );
                break;
        }
    }

    _setupShareDentistSettings(ID = 0, element = "", value = null) {
        this.dentistShareSettings.ID = ID;
        this.dentistShareSettings.element = element;
        this.dentistShareSettings.value = value;
    }

    _disableDentistShareOnNonAvailability(element) {
        const sharingTextElement = element.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(
            ".note.dental-sharing-on-text"
        );

        const targetPartnerSelect = document.querySelector(
            `[data-share-dentist-id="${this.dentistShareSettings.ID}"] > select`
        );

        // if targetPartnerSelect isn't available: stop _handleDentistShareOnNonAvailability, otherwise proceed
        if (!targetPartnerSelect) return;

        const correspondingPartnerAvID = targetPartnerSelect.value;
        const correspondingPartnerAvSelect = document.querySelector(
            `[data-share-dentist-av="${correspondingPartnerAvID}"]`
        );

        // 1. enforce state way forward from Sharing-Initiator to Sharing-Receiver [->]
        this._initiatorToReceiver(
            correspondingPartnerAvSelect,
            targetPartnerSelect,
            correspondingPartnerAvID,
            sharingTextElement
        );

        // 2. enforce state the way back from Sharing-Receiver to Sharing-Initiator [<-]
        this._receiverToInitiator(
            correspondingPartnerAvSelect,
            correspondingPartnerAvID,
            sharingTextElement
        );

        // Reset empty Av selectbox to last remembered AV
        this._resetEmptyAvSelects();
    }

    _initiatorToReceiver(
        correspondingPartnerAvSelect,
        targetPartnerSelect,
        correspondingPartnerAvID,
        sharingTextElement
    ) {
        const dentistShareCheckBoxAssociatedwithAvSelectElement = document.querySelector(
            `[data-share-dentist-id="${
                this.dentistShareSettings.ID
            }"] > [type="checkbox"]`
        );
        const correspondingPartnerAvSelectIDs = Array.from(
            correspondingPartnerAvSelect.querySelectorAll("option")
        ).map(elem => elem.value);

        if (
            correspondingPartnerAvSelectIDs.includes(
                this.dentistShareSettings.value
            )
        ) {
            this._enableSharing(
                dentistShareCheckBoxAssociatedwithAvSelectElement,
                targetPartnerSelect
            );
        } else {
            this._disableSharing(
                dentistShareCheckBoxAssociatedwithAvSelectElement,
                sharingTextElement
            );
        }
    }

    _receiverToInitiator(
        correspondingPartnerAvSelect,
        correspondingPartnerAvID,
        sharingTextElement
    ) {
        const avSelectValues = Array.from(
            this.dentistShareSettings.element.querySelectorAll("option")
        ).map(elem => elem.value);
        const correspondingPartnerAvSelectValue =
            correspondingPartnerAvSelect.value;
        const correspondingPartnerDentistShareCheckBoxAssociatedwithAvSelectElement = document.querySelector(
            `[data-share-dentist-id="${correspondingPartnerAvID}"] > [type="checkbox"]`
        );
        const correspondingPartnerDentistShareSelectElement = document.querySelector(
            `[data-share-dentist-id="${correspondingPartnerAvID}"] > select`
        );

        const allDentistShareValues = Array.from(
            document.querySelectorAll(`[data-disabled-dentist-share]`)
        ).map(elem => elem.getAttribute("data-disabled-dentist-share"));

        if (
            avSelectValues.includes(correspondingPartnerAvSelectValue) ||
            allDentistShareValues.every(el => el === "false")
        ) {
            this._enableSharing(
                correspondingPartnerDentistShareCheckBoxAssociatedwithAvSelectElement,
                correspondingPartnerDentistShareSelectElement
            );
        } else {
            this._disableSharing(
                correspondingPartnerDentistShareCheckBoxAssociatedwithAvSelectElement,
                sharingTextElement
            );
        }
    }

    _enableSharing(checkbox, select) {
        checkbox.dataset.disabledDentistShare = false;
        checkbox.removeAttribute("disabled");
        select.removeAttribute("disabled");
    }

    _disableSharing(checkbox, text) {
        checkbox.dataset.disabledDentistShare = true;
        checkbox.setAttribute("disabled", "disabled");
        checkbox.checked = false;
        text.style.display = "none";
    }

    _resetEmptyAvSelects() {
        for (let avSelect of this.avSelects) {
            let avSelectElementValue = avSelect.value;
            let avSelectElementValueOld = avSelect.getAttribute(
                "data-share-dentist-av-remember"
            );

            if (!avSelectElementValue) {
                avSelect.value = avSelectElementValueOld;
                avSelect.dispatchEvent(new Event("change"));
            }
        }
    }
}
